export type WizardStep = 'supplier' | 'document' | 'items' | 'checklist' | 'storage' | 'summary';

export const WIZARD_STEP_ORDER: readonly WizardStep[] = [
  'supplier',
  'document',
  'items',
  'checklist',
  'storage',
  'summary',
];

export type WizardDirection = 'forward' | 'backward' | 'none';

const WIZARD_REGISTER_PATH_PREFIX = '/goods-receiving/register/';

export function isWizardStep(pathSegment: string): pathSegment is WizardStep {
  return (WIZARD_STEP_ORDER as readonly string[]).includes(pathSegment);
}

export function isWizardRegisterPath(pathname: string): boolean {
  return pathname.startsWith(WIZARD_REGISTER_PATH_PREFIX);
}

export function resolveWizardDirection(
  previousStep: WizardStep | null,
  currentStep: WizardStep,
): WizardDirection {
  if (previousStep === null) {
    return 'none';
  }
  const previousIndex = WIZARD_STEP_ORDER.indexOf(previousStep);
  const currentIndex = WIZARD_STEP_ORDER.indexOf(currentStep);
  if (previousIndex < 0 || currentIndex < 0 || previousIndex === currentIndex) {
    return 'none';
  }
  return currentIndex > previousIndex ? 'forward' : 'backward';
}

export function getWizardStepNumber(step: string | null | undefined): number {
  const index = WIZARD_STEP_ORDER.indexOf(step as WizardStep);
  return index >= 0 ? index + 1 : 1;
}
